import CollapsedPanel from "../components/CollapsedPanel";
import React from "react";
import CommonStylingPanel from "./CommonStylingPanel";

export default function TakeoverStylingPanel() {
  return (
    <CollapsedPanel open={false} title="Page Takeover Styling">
      <CommonStylingPanel/>
    </CollapsedPanel>
  )
}
